import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInventory = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.29999 11.1111H14.7M19.8003 7.55556V18.2222C19.8003 19.2044 18.9948 20 18.0003 20H5.99969C5.00519 20 4.19969 19.2044 4.19969 18.2222V7.55556M20.1 7.55556H3.89999C3.40319 7.55556 2.99999 7.15733 2.99999 6.66667V4.88889C2.99999 4.39822 3.40319 4 3.89999 4H20.1C20.5968 4 21 4.39822 21 4.88889V6.66667C21 7.15733 20.5968 7.55556 20.1 7.55556Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgInventory);
export default ForwardRef;
